"use strict";
/**
 * The content model as the wire sees it.
 *
 * Metadata is relational on the server; the authored document is one JSONB
 * column of `IBlock[]`. That split is the whole design: versioning, authoring
 * and rendering all get simpler with a document, and search and analytics stay
 * on the relational side where they belong.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRADED_BLOCK_TYPES = exports.BLOCK_TYPES = exports.CONTENT_STATUSES = exports.ACCESS_TIERS = exports.ACADEMY_LABELS = exports.ACADEMIES = void 0;
/** Which academy a course belongs to. Straight from the outline's section 1. */
exports.ACADEMIES = ['teacher', 'trainer', 'leadership', 'student'];
exports.ACADEMY_LABELS = {
    teacher: 'Professional Learning Academy — Teacher Courses',
    trainer: 'Teacher Trainer Academy',
    leadership: 'School Leadership Academy',
    student: 'Student Learning Centre',
};
/**
 * Free or premium, on the row itself.
 *
 * The outline splits every section into FREE and PREMIUM lists, so this is not
 * an abstraction over the requirement — it is the requirement, one column.
 * What a plan includes is a separate table; this only says what a thing costs
 * to reach.
 */
exports.ACCESS_TIERS = ['free', 'premium'];
exports.CONTENT_STATUSES = ['draft', 'review', 'published', 'archived'];
exports.BLOCK_TYPES = [
    'rich_text',
    'video',
    'audio',
    'image',
    'callout',
    'mcq',
    'numeric',
    'drag_match',
    'reflection',
    'lab_embed',
    'download',
];
/** Block types a learner can be scored on. Everything else is exposition. */
exports.GRADED_BLOCK_TYPES = ['mcq', 'numeric', 'drag_match'];
//# sourceMappingURL=content.js.map